import axios from 'axios';
// 创建 axios 实例
const http = axios.create({
    baseURL: process.env.VUE_APP_API_BASE,
    timeout: 0, // 无超时限制，一直等待响应
    headers: {
        'Content-Type': 'application/json',
    },
});
// 请求拦截器
http.interceptors.request.use((config) => {
    // 可以在这里添加 token 等认证信息
    const token = localStorage.getItem('auth_token') || localStorage.getItem('token');
    if (token && config.headers) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    console.log('发送请求:', config);
    return config;
}, (error) => {
    console.error('请求错误:', error);
    return Promise.reject(error);
});
// 响应拦截器
http.interceptors.response.use((response) => {
    const data = response?.data;
    // If backend returns a plain string, pass it through
    if (typeof data === 'string') {
        return data;
    }
    // Normalize object responses
    if (typeof data === 'object' && data !== null) {
        // If backend uses a standard wrapper with code
        if (typeof data.code === 'number') {
            if (data.code === 200 || data.code === 0) {
                // Try to unwrap common payload patterns
                if ('token' in data)
                    return data;
                if ('data' in data)
                    return data.data;
                return data;
            }
            else if (data.code === 401) {
                // Unauthorized - redirect to login
                if (typeof window !== 'undefined') {
                    window.location.href = '/';
                }
                return Promise.reject(new Error(data.msg || data.message || '未授权'));
            }
            else {
                const errMsg = data.msg || data.message || '请求失败';
                console.error('业务错误:', errMsg);
                return Promise.reject(new Error(errMsg));
            }
        }
        // For our chat API, the response should have 'reply' field
        // If it has 'reply', it's a chat response, return as is
        if ('reply' in data) {
            return data;
        }
        // If no code field, pass through the data as payload
        if ('token' in data)
            return data;
        if ('data' in data)
            return data.data;
        return data;
    }
    return data;
}, (error) => {
    console.error('响应错误:', error);
    // 直接返回错误，不重试
    let message = '网络错误';
    if (error.response) {
        // 服务器返回了错误状态码
        switch (error.response.status) {
            case 400:
                message = '请求参数错误';
                break;
            case 401:
                message = '未授权，请重新登录';
                // 可以在这里跳转到登录页面
                break;
            case 403:
                message = '拒绝访问';
                break;
            case 404:
                message = '请求资源不存在';
                break;
            case 500:
                message = '服务器内部错误';
                break;
            default:
                message = `错误代码: ${error.response.status}`;
        }
    }
    else if (error.request) {
        message = '网络连接失败';
    }
    return Promise.reject(new Error(message));
});
export default http;
